import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/vin_records',
  component: Management,
  redirect: '/vin_records/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/vin_records/List'),
      meta: {
        auth: Auth.listVinRecords
      }
    }
  ]
}
